import React from "react";
import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import { RadarChart, Radar, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Tooltip, ResponsiveContainer } from "recharts";
import theme from "../../theme";
import "./chartStyles.css"; // Import the CSS file

const RadarChartComponent = ({ data, title }) => {
  const bgColor = useColorModeValue('chart-box', 'chart-box-dark');
  const textColor = useColorModeValue("chart-title", "chart-title-dark");
  const chartColors = Object.values(theme.colors.chartColors);
  const dividerColor = useColorModeValue(theme.colors.dividerColor.light, theme.colors.dividerColor.dark);

  return (
    <Box className={`${bgColor} chart-hover-effect`}>
      <Text mb={3} fontSize="xl" fontWeight="600" color={textColor}>
        {title}
      </Text>
      <Box className="divider"></Box>
      <Box width="100%" height="2px" background={dividerColor} mb={4} />
      <Box display="flex" flexDirection="column" alignItems="center">
        <ResponsiveContainer width="100%" height={300} minWidth="200px">
          <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
            <PolarGrid />
            <PolarAngleAxis dataKey="subject" tick={{ fontSize: 12}} />
            <PolarRadiusAxis angle={30} domain={[0, 100]} />
            <Radar dataKey="A" stroke={chartColors[0]} fill={chartColors[0]} fillOpacity={0.6} />
            <Tooltip
              labelFormatter={(label) => {
                return (
                  <span className={'tooltip-title'} >
                  {label}
                </span>
                );
              }}
              />
          </RadarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default RadarChartComponent;
